import React, { Component } from 'react'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import PasswordResetStep2UI from './PasswordResetStep2UI.js'

class PasswordResetStep2SF extends Component {
  constructor(props) {
    super(props)
    let params = new URLSearchParams(window.location.search)
    this.state = {
      errorList: [],
      submitted: false,
      // email
      email: params.has('identity') ? params.get('identity') : '',
      emailError: null,
      // reset code
      resetCode: params.has('code') ? params.get('code') : '',
      resetCodeError: null,
      // new password
      newPassword: '',
      newPasswordError: null
    }
  }

  render() {
    return (
      <PasswordResetStep2UI
        context={this.props.context}
        messageList={this.props.messageList}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={(errorList) => {this.setState({errorList: errorList})}}
        // email
        email={this.state.email}
        emailError={this.state.emailError}
        onEmailChange={(event) => {this.setState({email: event.target.value})}}
        setEmailError={(error) => {this.setState({emailError: error})}}
        // reset code
        resetCode={this.state.resetCode}
        resetCodeError={this.state.resetCodeError}
        onResetCodeChange={(event) => {this.setState({resetCode: event.target.value})}}
        setResetCodeError={(error) => {this.setState({resetCodeError: error})}}
        // new password
        newPassword={this.state.newPassword}
        newPasswordError={this.state.newPasswordError}
        onNewPasswordChange={(event) => {this.setState({newPassword: event.target.value})}}
        setNewPasswordError={(error) => {this.setState({newPasswordError: error})}}
      />
    )
  }

  UNSAFE_componentWillMount() {
    // let context = this.props.context
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return
    this.setState({submitted: true})

    RestApiUtils.put(this.props.context,
      '/api/pub/passwordReset',
      this.onPasswordResetStep2Callback, {
        email: this.state.email,
        resetCode: this.state.resetCode,
        newPassword: this.state.newPassword
      }
    )
  }

  onPasswordResetStep2Callback = (response) => {
    let errorList = []
    this.setState({submitted: false})

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch(error.fieldName) {
          case 'email':
            this.setState({emailError: error.message})
            break;
          case 'resetCode':
            this.setState({resetCodeError: error.message})
            break;
          case 'newPassword':
            this.setState({newPasswordError: error.message})
            break;
          default:
        }
      })
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList
    })

    if (errorList.length === 0) {
      this.props.context.onLogin(response.session)
    }
  }
}

export default PasswordResetStep2SF
